<footer class="footer" role="contentinfo">
  <div class="footer__inner">
    <div class="footer__grid">
      @if (brandName().trim().length) {
        <div class="footer__col footer__col--brand">
          @if (isPaidServicesRoute()) {
            <img src="assets/images/logos/wellvia/welliva-white text.svg" [alt]="brandName()" class="footer__brand footer__brand--wellvia" />
          } @else {
            <img src="assets/images/logos/epak/e-perearstikeskus-white-text.svg" [alt]="brandName()" class="footer__brand" />
          }
        </div>
      } @else {
        <div class="footer__col footer__col--spacer" aria-hidden="true"></div>
      }
      <div class="footer__col footer__col--links"
           [class.footer__col--hidden]="isPaidServicesRoute()">
        <a routerLink="/video-guides" class="footer__link">{{ 'footer.videoGuides' | translate }}</a>
        <a routerLink="/emo" class="footer__link footer__link--nowrap">{{ 'footer.shouldYouGoToEmo' | translate }}</a>
        <a routerLink="/practitioners" class="footer__link">{{ 'footer.joinedCenters' | translate }}</a>
      </div>
      <div class="footer__col footer__col--links">
        <a routerLink="/terms" class="footer__link">{{ 'footer.termsAndConditions' | translate }}</a>
        <a routerLink="/privacy" class="footer__link">{{ 'footer.privacyPolicy' | translate }}</a>
        <a routerLink="/price-list" class="footer__link">{{ 'footer.priceList' | translate }}</a>
      </div>
      <div class="footer__col footer__col--contact">
        <span class="footer__contact-title">{{ 'footer.customerService' | translate }}</span>
        <a [href]="mailToHref"
           class="footer__contact-link">
          {{ customerService }}
        </a>
        <span class="footer__contact-text">{{ 'footer.openingHours' | translate }}</span>
        <span class="footer__contact-text">{{ 'footer.companyName' | translate }}</span>
        <span class="footer__contact-text">{{ ('footer.sessionId' | translate) + sessionId }}</span>
      </div>
    </div>
  </div>
</footer>
